// helpData.js
// helpData.js
export const helpData = {
    courseMaster: {
        title: "Course Master",
        description: "Create and manage courses offered by the school.",
        tips: [
            "Define each course with a clear name and code.",
            "Ensure course duration and class levels are set correctly.",
            "Link subjects later through Subject Master."
        ],
        demoLink: "/demo/course-master"
    },
    subjectMaster: {
        title: "Subject Master",
        description: "Add subjects that belong to different courses.",
        tips: [
            "Create core subjects first (Math, Science, English).",
            "Assign subjects to the relevant course.",
            "Use consistent naming for easier reporting."
        ],
        demoLink: "/demo/subject-master"
    },
    feeHeadMaster: {
        title: "Fee Head Master",
        description: "Define fee heads like Tuition Fee, Examination Fee, etc.",
        tips: [
            "Create all standard fee heads before grouping.",
            "Keep names short and descriptive.",
            "Avoid duplication to maintain clean reports."
        ],
        demoLink: "/demo/fee-head-master"
    },
    feeGroup: {
        title: "Fee Group",
        description: "Group fee heads into categories like New Admission, EWS, etc.",
        tips: [
            "Use fee groups to differentiate student categories.",
            "Link appropriate fee heads to each group.",
            "Review group totals before saving."
        ],
        demoLink: "/demo/fee-group"
    },
    feeSlab: {
        title: "Fee Slab",
        description: "Create course-specific fee structures with amounts.",
        tips: [
            "Select the course and fee group before defining slabs.",
            "Enter correct amounts for each fee head.",
            "Double-check totals to avoid billing errors."
        ],
        demoLink: "/demo/fee-slab"
    },
    leadMaster: {
        title: "Lead Master",
        description: "Create and manage new student leads.",
        tips: [
            "Enter complete contact details for each lead.",
            "Track status changes (e.g., Admission Confirm).",
            "Use filters to quickly find pending leads."
        ],
        demoLink: "/demo/lead-master"
    },
    enrollment: {
        title: "Enrollment",
        description: "Enroll confirmed leads into courses and batches.",
        tips: [
            "Select the correct course and batch.",
            "Apply the relevant fee slab.",
            "Save enrollment before generating installments."
        ],
        demoLink: "/demo/enrollment"
    },
    batchMaster: {
        title: "Batch Master",
        description: "Create batches for each class under enrollment.",
        tips: [
            "Name batches clearly (e.g., Grade 5 - Section A).",
            "Assign teachers and schedules if applicable.",
            "Link batches to the correct fee slab."
        ],
        demoLink: "/demo/batch-master"
    },
    discountModule: {
        title: "Discounts",
        description: "Apply discounts to enrolled students if applicable.",
        tips: [
            "Enter discount percentage or fixed amount.",
            "Ensure approval before applying discounts.",
            "Discounts reflect in installment generation."
        ],
        demoLink: "/demo/discounts"
    },
    installmentModule: {
        title: "Fee Installments",
        description: "Generate fee installments (monthly, half-yearly, yearly).",
        tips: [
            "Choose installment frequency carefully.",
            "Verify total matches fee slab minus discounts.",
            "Communicate installment schedule to parents."
        ],
        demoLink: "/demo/installments"
    },
    feeReceiptMaster: {
        title: "Fee Receipt Master",
        description: "Create and manage fee receipts for payments.",
        tips: [
            "Select the correct student and installment.",
            "Record payment mode (cash, card, online).",
            "Verify receipt before printing or emailing."
        ],
        demoLink: "/demo/fee-receipt-master"
    },
    admissions: {
        title: "Admissions Module",
        description: "Handles student enrollment and registration.",
        tips: [
            "Use the search bar to quickly find applicants.",
            "Check required documents before approving."
        ],
        demoLink: "/demo/admissions"
    },
    attendance: {
        title: "Attendance Module",
        description: "Track daily student attendance.",
        tips: [
            "Mark absentees before 10 AM.",
            "Export attendance reports monthly."
        ],
        demoLink: "/demo/attendance"
    },
    workflowGuide: { title: "Workflow Guide", description: "Step-by-step instructions to set up and run the system.", steps: 
        [{ step: 1, title: "One-time Setup", details: ["Create courses in Course Master", "Add subjects in Subject Master", "Define fee heads (Tuition Fee, Examination Fee, etc.) in Fee Head Master", "Group fee heads into categories (New Admission, EWS, etc.) in Fee Group", "Create course-specific fee slabs with amounts in Fee Slab Master"], link: "/demo/course-master" }, 
        { step: 2, title: "Admissions Flow", details: ["Create new leads in Lead Master", "View leads and change status to Admission Confirm", "Enroll confirmed leads in Enrollment", "Create batches for the class and select applicable fee slab"], link: "/demo/enrollment" },
         { step: 3, title: "Finance Flow", details: ["Provide discounts if applicable", "Generate fee installments (monthly, half-yearly, yearly)", "Create fee receipts in Fee Receipt Master"], link: "/demo/fee-receipt-master" }
        ]}
};


